import { render, staticRenderFns } from "./PostalCodeView.vue?vue&type=template&id=2c6c1e82&"
import script from "./PostalCodeView.vue?vue&type=script&lang=js&"
export * from "./PostalCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports